import React, {Component} from 'react'
import {connect} from 'react-redux'
import {appSelectors} from '@/store'
import type {Language} from '@/types'
import RawPermissionBox from './permission-box'

import './index.css'

type Props = {
  l: Language,
  permissions: Array<string>,
  setPermissions: (Array, number) => void,
  id: number,
  disableAll: boolean,
}

const PermissionList = ['View', 'Add', 'Edit', 'Remove']

export class RawUserPermissions extends Component<Props> {
  updatePermissions = (id, key, val) => {
    let permissions = this.props.permissions
    if (val) {
      permissions.push(key)
      if (key !== 'View' && permissions.indexOf('View') === -1) {
        permissions.push('View')
      }
    } else {
      if (key === 'View') {
        permissions = []
      } else {
        let index = permissions.indexOf(key)
        permissions.splice(index, 1)
      }
    }
    this.props.setPermissions(permissions.join(','), id)
  }

  renderPermissions = (data: Array<string>, id: number) => {
    const permissions = data.map((text) => text.trim())

    return PermissionList.map((permission: string, index) => {
      return (
        <RawPermissionBox key={id + permission} name={permission} isAllowed={permissions.indexOf(permission) > -1}
          update={this.updatePermissions} userId={id} disable={this.props.disableAll}/>
      )
    })
  }

  render = () =>
    <div className="btn-group" data-toggle="buttons">{this.renderPermissions(this.props.permissions, this.props.id)}</div>
}

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
)(RawUserPermissions)



// WEBPACK FOOTER //
// ./src/views/forms/share-portfolio/user-permissions.js